/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as BloodReportRoleGuardRouteImport } from './routes/blood-report/_role-guard'
import { Route as BloodReportRoleGuardIdRouteImport } from './routes/blood-report/_role-guard/$id'
import { Route as BloodReportRoleGuardIdViewRouteImport } from './routes/blood-report/_role-guard/$id/view'
import { Route as BloodReportRoleGuardIdPublishedRouteImport } from './routes/blood-report/_role-guard/$id/published'
import { Route as BloodReportRoleGuardIdReportRouteImport } from './routes/blood-report/_role-guard/$id/_report'
import { Route as BloodReportRoleGuardIdReportIndexRouteImport } from './routes/blood-report/_role-guard/$id/_report/index'
import { Route as BloodReportRoleGuardIdReportPreviewRouteImport } from './routes/blood-report/_role-guard/$id/_report/preview'
import { Route as BloodReportRoleGuardIdDocumentsRadiologyReportStudyIdRouteImport } from './routes/blood-report/_role-guard/$id/documents/radiology-report/$studyId'
import { Route as BloodReportRoleGuardIdDocumentsMhsStudyIdRouteImport } from './routes/blood-report/_role-guard/$id/documents/mhs/$studyId'
import { Route as BloodReportRoleGuardIdDocumentsCwfStudyStudyIdTypeIdRouteImport } from './routes/blood-report/_role-guard/$id/documents/cwf/study/$studyId/$typeId'
import { Route as BloodReportRoleGuardIdDocumentsCwfCareActivityCareActivityIdTypeIdRouteImport } from './routes/blood-report/_role-guard/$id/documents/cwf/care-activity/$careActivityId/$typeId'

const BloodReportRoleGuardRoute = BloodReportRoleGuardRouteImport.update({
  id: '/blood-report/_role-guard',
  path: '/blood-report',
  getParentRoute: () => rootRouteImport,
} as any)
const BloodReportRoleGuardIdRoute = BloodReportRoleGuardIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => BloodReportRoleGuardRoute,
} as any)
const BloodReportRoleGuardIdViewRoute =
  BloodReportRoleGuardIdViewRouteImport.update({
    id: '/view',
    path: '/view',
    getParentRoute: () => BloodReportRoleGuardIdRoute,
  } as any)
const BloodReportRoleGuardIdPublishedRoute =
  BloodReportRoleGuardIdPublishedRouteImport.update({
    id: '/published',
    path: '/published',
    getParentRoute: () => BloodReportRoleGuardIdRoute,
  } as any)
const BloodReportRoleGuardIdReportRoute =
  BloodReportRoleGuardIdReportRouteImport.update({
    id: '/_report',
    getParentRoute: () => BloodReportRoleGuardIdRoute,
  } as any)
const BloodReportRoleGuardIdReportIndexRoute =
  BloodReportRoleGuardIdReportIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BloodReportRoleGuardIdReportRoute,
  } as any)
const BloodReportRoleGuardIdReportPreviewRoute =
  BloodReportRoleGuardIdReportPreviewRouteImport.update({
    id: '/preview',
    path: '/preview',
    getParentRoute: () => BloodReportRoleGuardIdReportRoute,
  } as any)
const BloodReportRoleGuardIdDocumentsRadiologyReportStudyIdRoute =
  BloodReportRoleGuardIdDocumentsRadiologyReportStudyIdRouteImport.update({
    id: '/documents/radiology-report/$studyId',
    path: '/documents/radiology-report/$studyId',
    getParentRoute: () => BloodReportRoleGuardIdRoute,
  } as any)
const BloodReportRoleGuardIdDocumentsMhsStudyIdRoute =
  BloodReportRoleGuardIdDocumentsMhsStudyIdRouteImport.update({
    id: '/documents/mhs/$studyId',
    path: '/documents/mhs/$studyId',
    getParentRoute: () => BloodReportRoleGuardIdRoute,
  } as any)
const BloodReportRoleGuardIdDocumentsCwfStudyStudyIdTypeIdRoute =
  BloodReportRoleGuardIdDocumentsCwfStudyStudyIdTypeIdRouteImport.update({
    id: '/documents/cwf/study/$studyId/$typeId',
    path: '/documents/cwf/study/$studyId/$typeId',
    getParentRoute: () => BloodReportRoleGuardIdRoute,
  } as any)
const BloodReportRoleGuardIdDocumentsCwfCareActivityCareActivityIdTypeIdRoute =
  BloodReportRoleGuardIdDocumentsCwfCareActivityCareActivityIdTypeIdRouteImport.update(
    {
      id: '/documents/cwf/care-activity/$careActivityId/$typeId',
      path: '/documents/cwf/care-activity/$careActivityId/$typeId',
      getParentRoute: () => BloodReportRoleGuardIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/blood-report': typeof BloodReportRoleGuardRouteWithChildren
  '/blood-report/$id': typeof BloodReportRoleGuardIdReportRouteWithChildren
  '/blood-report/$id/published': typeof BloodReportRoleGuardIdPublishedRoute
  '/blood-report/$id/view': typeof BloodReportRoleGuardIdViewRoute
  '/blood-report/$id/preview': typeof BloodReportRoleGuardIdReportPreviewRoute
  '/blood-report/$id/': typeof BloodReportRoleGuardIdReportIndexRoute
  '/blood-report/$id/documents/mhs/$studyId': typeof BloodReportRoleGuardIdDocumentsMhsStudyIdRoute
  '/blood-report/$id/documents/radiology-report/$studyId': typeof BloodReportRoleGuardIdDocumentsRadiologyReportStudyIdRoute
  '/blood-report/$id/documents/cwf/care-activity/$careActivityId/$typeId': typeof BloodReportRoleGuardIdDocumentsCwfCareActivityCareActivityIdTypeIdRoute
  '/blood-report/$id/documents/cwf/study/$studyId/$typeId': typeof BloodReportRoleGuardIdDocumentsCwfStudyStudyIdTypeIdRoute
}
export interface FileRoutesByTo {
  '/blood-report': typeof BloodReportRoleGuardRouteWithChildren
  '/blood-report/$id': typeof BloodReportRoleGuardIdReportIndexRoute
  '/blood-report/$id/published': typeof BloodReportRoleGuardIdPublishedRoute
  '/blood-report/$id/view': typeof BloodReportRoleGuardIdViewRoute
  '/blood-report/$id/preview': typeof BloodReportRoleGuardIdReportPreviewRoute
  '/blood-report/$id/documents/mhs/$studyId': typeof BloodReportRoleGuardIdDocumentsMhsStudyIdRoute
  '/blood-report/$id/documents/radiology-report/$studyId': typeof BloodReportRoleGuardIdDocumentsRadiologyReportStudyIdRoute
  '/blood-report/$id/documents/cwf/care-activity/$careActivityId/$typeId': typeof BloodReportRoleGuardIdDocumentsCwfCareActivityCareActivityIdTypeIdRoute
  '/blood-report/$id/documents/cwf/study/$studyId/$typeId': typeof BloodReportRoleGuardIdDocumentsCwfStudyStudyIdTypeIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/blood-report/_role-guard': typeof BloodReportRoleGuardRouteWithChildren
  '/blood-report/_role-guard/$id': typeof BloodReportRoleGuardIdRouteWithChildren
  '/blood-report/_role-guard/$id/_report': typeof BloodReportRoleGuardIdReportRouteWithChildren
  '/blood-report/_role-guard/$id/published': typeof BloodReportRoleGuardIdPublishedRoute
  '/blood-report/_role-guard/$id/view': typeof BloodReportRoleGuardIdViewRoute
  '/blood-report/_role-guard/$id/_report/preview': typeof BloodReportRoleGuardIdReportPreviewRoute
  '/blood-report/_role-guard/$id/_report/': typeof BloodReportRoleGuardIdReportIndexRoute
  '/blood-report/_role-guard/$id/documents/mhs/$studyId': typeof BloodReportRoleGuardIdDocumentsMhsStudyIdRoute
  '/blood-report/_role-guard/$id/documents/radiology-report/$studyId': typeof BloodReportRoleGuardIdDocumentsRadiologyReportStudyIdRoute
  '/blood-report/_role-guard/$id/documents/cwf/care-activity/$careActivityId/$typeId': typeof BloodReportRoleGuardIdDocumentsCwfCareActivityCareActivityIdTypeIdRoute
  '/blood-report/_role-guard/$id/documents/cwf/study/$studyId/$typeId': typeof BloodReportRoleGuardIdDocumentsCwfStudyStudyIdTypeIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/blood-report'
    | '/blood-report/$id'
    | '/blood-report/$id/published'
    | '/blood-report/$id/view'
    | '/blood-report/$id/preview'
    | '/blood-report/$id/'
    | '/blood-report/$id/documents/mhs/$studyId'
    | '/blood-report/$id/documents/radiology-report/$studyId'
    | '/blood-report/$id/documents/cwf/care-activity/$careActivityId/$typeId'
    | '/blood-report/$id/documents/cwf/study/$studyId/$typeId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/blood-report'
    | '/blood-report/$id'
    | '/blood-report/$id/published'
    | '/blood-report/$id/view'
    | '/blood-report/$id/preview'
    | '/blood-report/$id/documents/mhs/$studyId'
    | '/blood-report/$id/documents/radiology-report/$studyId'
    | '/blood-report/$id/documents/cwf/care-activity/$careActivityId/$typeId'
    | '/blood-report/$id/documents/cwf/study/$studyId/$typeId'
  id:
    | '__root__'
    | '/blood-report/_role-guard'
    | '/blood-report/_role-guard/$id'
    | '/blood-report/_role-guard/$id/_report'
    | '/blood-report/_role-guard/$id/published'
    | '/blood-report/_role-guard/$id/view'
    | '/blood-report/_role-guard/$id/_report/preview'
    | '/blood-report/_role-guard/$id/_report/'
    | '/blood-report/_role-guard/$id/documents/mhs/$studyId'
    | '/blood-report/_role-guard/$id/documents/radiology-report/$studyId'
    | '/blood-report/_role-guard/$id/documents/cwf/care-activity/$careActivityId/$typeId'
    | '/blood-report/_role-guard/$id/documents/cwf/study/$studyId/$typeId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  BloodReportRoleGuardRoute: typeof BloodReportRoleGuardRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/blood-report/_role-guard': {
      id: '/blood-report/_role-guard'
      path: '/blood-report'
      fullPath: '/blood-report'
      preLoaderRoute: typeof BloodReportRoleGuardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blood-report/_role-guard/$id': {
      id: '/blood-report/_role-guard/$id'
      path: '/$id'
      fullPath: '/blood-report/$id'
      preLoaderRoute: typeof BloodReportRoleGuardIdRouteImport
      parentRoute: typeof BloodReportRoleGuardRoute
    }
    '/blood-report/_role-guard/$id/view': {
      id: '/blood-report/_role-guard/$id/view'
      path: '/view'
      fullPath: '/blood-report/$id/view'
      preLoaderRoute: typeof BloodReportRoleGuardIdViewRouteImport
      parentRoute: typeof BloodReportRoleGuardIdRoute
    }
    '/blood-report/_role-guard/$id/published': {
      id: '/blood-report/_role-guard/$id/published'
      path: '/published'
      fullPath: '/blood-report/$id/published'
      preLoaderRoute: typeof BloodReportRoleGuardIdPublishedRouteImport
      parentRoute: typeof BloodReportRoleGuardIdRoute
    }
    '/blood-report/_role-guard/$id/_report': {
      id: '/blood-report/_role-guard/$id/_report'
      path: ''
      fullPath: '/blood-report/$id'
      preLoaderRoute: typeof BloodReportRoleGuardIdReportRouteImport
      parentRoute: typeof BloodReportRoleGuardIdRoute
    }
    '/blood-report/_role-guard/$id/_report/': {
      id: '/blood-report/_role-guard/$id/_report/'
      path: '/'
      fullPath: '/blood-report/$id/'
      preLoaderRoute: typeof BloodReportRoleGuardIdReportIndexRouteImport
      parentRoute: typeof BloodReportRoleGuardIdReportRoute
    }
    '/blood-report/_role-guard/$id/_report/preview': {
      id: '/blood-report/_role-guard/$id/_report/preview'
      path: '/preview'
      fullPath: '/blood-report/$id/preview'
      preLoaderRoute: typeof BloodReportRoleGuardIdReportPreviewRouteImport
      parentRoute: typeof BloodReportRoleGuardIdReportRoute
    }
    '/blood-report/_role-guard/$id/documents/radiology-report/$studyId': {
      id: '/blood-report/_role-guard/$id/documents/radiology-report/$studyId'
      path: '/documents/radiology-report/$studyId'
      fullPath: '/blood-report/$id/documents/radiology-report/$studyId'
      preLoaderRoute: typeof BloodReportRoleGuardIdDocumentsRadiologyReportStudyIdRouteImport
      parentRoute: typeof BloodReportRoleGuardIdRoute
    }
    '/blood-report/_role-guard/$id/documents/mhs/$studyId': {
      id: '/blood-report/_role-guard/$id/documents/mhs/$studyId'
      path: '/documents/mhs/$studyId'
      fullPath: '/blood-report/$id/documents/mhs/$studyId'
      preLoaderRoute: typeof BloodReportRoleGuardIdDocumentsMhsStudyIdRouteImport
      parentRoute: typeof BloodReportRoleGuardIdRoute
    }
    '/blood-report/_role-guard/$id/documents/cwf/study/$studyId/$typeId': {
      id: '/blood-report/_role-guard/$id/documents/cwf/study/$studyId/$typeId'
      path: '/documents/cwf/study/$studyId/$typeId'
      fullPath: '/blood-report/$id/documents/cwf/study/$studyId/$typeId'
      preLoaderRoute: typeof BloodReportRoleGuardIdDocumentsCwfStudyStudyIdTypeIdRouteImport
      parentRoute: typeof BloodReportRoleGuardIdRoute
    }
    '/blood-report/_role-guard/$id/documents/cwf/care-activity/$careActivityId/$typeId': {
      id: '/blood-report/_role-guard/$id/documents/cwf/care-activity/$careActivityId/$typeId'
      path: '/documents/cwf/care-activity/$careActivityId/$typeId'
      fullPath: '/blood-report/$id/documents/cwf/care-activity/$careActivityId/$typeId'
      preLoaderRoute: typeof BloodReportRoleGuardIdDocumentsCwfCareActivityCareActivityIdTypeIdRouteImport
      parentRoute: typeof BloodReportRoleGuardIdRoute
    }
  }
}

interface BloodReportRoleGuardIdReportRouteChildren {
  BloodReportRoleGuardIdReportPreviewRoute: typeof BloodReportRoleGuardIdReportPreviewRoute
  BloodReportRoleGuardIdReportIndexRoute: typeof BloodReportRoleGuardIdReportIndexRoute
}

const BloodReportRoleGuardIdReportRouteChildren: BloodReportRoleGuardIdReportRouteChildren =
  {
    BloodReportRoleGuardIdReportPreviewRoute:
      BloodReportRoleGuardIdReportPreviewRoute,
    BloodReportRoleGuardIdReportIndexRoute:
      BloodReportRoleGuardIdReportIndexRoute,
  }

const BloodReportRoleGuardIdReportRouteWithChildren =
  BloodReportRoleGuardIdReportRoute._addFileChildren(
    BloodReportRoleGuardIdReportRouteChildren,
  )

interface BloodReportRoleGuardIdRouteChildren {
  BloodReportRoleGuardIdReportRoute: typeof BloodReportRoleGuardIdReportRouteWithChildren
  BloodReportRoleGuardIdPublishedRoute: typeof BloodReportRoleGuardIdPublishedRoute
  BloodReportRoleGuardIdViewRoute: typeof BloodReportRoleGuardIdViewRoute
  BloodReportRoleGuardIdDocumentsMhsStudyIdRoute: typeof BloodReportRoleGuardIdDocumentsMhsStudyIdRoute
  BloodReportRoleGuardIdDocumentsRadiologyReportStudyIdRoute: typeof BloodReportRoleGuardIdDocumentsRadiologyReportStudyIdRoute
  BloodReportRoleGuardIdDocumentsCwfCareActivityCareActivityIdTypeIdRoute: typeof BloodReportRoleGuardIdDocumentsCwfCareActivityCareActivityIdTypeIdRoute
  BloodReportRoleGuardIdDocumentsCwfStudyStudyIdTypeIdRoute: typeof BloodReportRoleGuardIdDocumentsCwfStudyStudyIdTypeIdRoute
}

const BloodReportRoleGuardIdRouteChildren: BloodReportRoleGuardIdRouteChildren =
  {
    BloodReportRoleGuardIdReportRoute:
      BloodReportRoleGuardIdReportRouteWithChildren,
    BloodReportRoleGuardIdPublishedRoute: BloodReportRoleGuardIdPublishedRoute,
    BloodReportRoleGuardIdViewRoute: BloodReportRoleGuardIdViewRoute,
    BloodReportRoleGuardIdDocumentsMhsStudyIdRoute:
      BloodReportRoleGuardIdDocumentsMhsStudyIdRoute,
    BloodReportRoleGuardIdDocumentsRadiologyReportStudyIdRoute:
      BloodReportRoleGuardIdDocumentsRadiologyReportStudyIdRoute,
    BloodReportRoleGuardIdDocumentsCwfCareActivityCareActivityIdTypeIdRoute:
      BloodReportRoleGuardIdDocumentsCwfCareActivityCareActivityIdTypeIdRoute,
    BloodReportRoleGuardIdDocumentsCwfStudyStudyIdTypeIdRoute:
      BloodReportRoleGuardIdDocumentsCwfStudyStudyIdTypeIdRoute,
  }

const BloodReportRoleGuardIdRouteWithChildren =
  BloodReportRoleGuardIdRoute._addFileChildren(
    BloodReportRoleGuardIdRouteChildren,
  )

interface BloodReportRoleGuardRouteChildren {
  BloodReportRoleGuardIdRoute: typeof BloodReportRoleGuardIdRouteWithChildren
}

const BloodReportRoleGuardRouteChildren: BloodReportRoleGuardRouteChildren = {
  BloodReportRoleGuardIdRoute: BloodReportRoleGuardIdRouteWithChildren,
}

const BloodReportRoleGuardRouteWithChildren =
  BloodReportRoleGuardRoute._addFileChildren(BloodReportRoleGuardRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  BloodReportRoleGuardRoute: BloodReportRoleGuardRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
